import type { AxiosRequestConfig } from 'axios';
import { backendApi } from '../api/backendApi';

export const apiClient = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const {
    method = 'GET',
    url,
    data,
    withCredentials = true,
    ...restConfig
  } = config;

  if (!url) {
    throw new Error('URL is required for API request');
  }

  let response: { data: T };

  switch (method.toUpperCase()) {
    case 'GET':
      response = await backendApi.get<T>(url, {
        ...restConfig,
        withCredentials,
      });
      break;
    case 'POST':
      response = await backendApi.post<T>(url, data, {
        ...restConfig,
        withCredentials,
      });
      break;
    case 'PUT':
      response = await backendApi.put<T>(url, data, {
        ...restConfig,
        withCredentials,
      });
      break;
    case 'PATCH':
      response = await backendApi.patch<T>(url, data, {
        ...restConfig,
        withCredentials,
      });
      break;
    case 'DELETE':
      response = await backendApi.delete<T>(url, {
        ...restConfig,
        withCredentials,
      });
      break;
    default:
      throw new Error(`Unsupported HTTP method: ${method}`);
  }

  return response.data;
};
